<template>
    <div :class="`new-folder dialog-wraper with-border`">
        <div :class="['folder-name',error ? 'form-error' : '']">
            <div class="form-input">
                <p class="dialog-label" v-cloak>{{$t('TeamLabel')}}</p>
                <el-input maxlength="100" ref="input" :placeholder="$t('TeamPlaceholder',{name})" @keyup.native.enter="create" v-model.trim="tname"></el-input>
            </div>
            <p v-if="error" class="name-error">{{$t(error)}}</p>
        </div>
        <div class="dialog-foot">
            <el-button 
                size="mini" 
                @click="cancel" 
                v-cloak>{{$t('Cancel')}}
            </el-button>
            <el-button 
                :loading="teamLoading" 
                :disabled="disabled" 
                @click="create" 
                type="primary" 
                size="mini" 
                v-cloak>{{$t('Confirm')}}
            </el-button>
        </div>
        
    </div>
</template>

<script>
import {mapMutations,mapState, mapActions} from 'vuex'
export default {
    data(){
        return {
            tname: '',
            error: ''
        }
    },
    mounted(){
        this.$refs.input.focus()
        this.tname = this.$t('TeamPlaceholder',{name: this.name})
    },
    computed:{
        ...mapState('user',[
            'name'
        ]),
        ...mapState('team',[
            'teamLoading'
        ]),
        disabled(){
            return !this.tname || !!this.error
        }
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        ...mapActions('team',[
            'createTeam'
        ]),
        cancel(){
            this.close()
        },
        create(){
            if (this.disabled) {
                return
            }
            this.createTeam({
                name: this.tname
            })
            
        }
    },
    watch:{
        tname(cur){
            let reg = /^[^/\\:*?"<>|]+$/
            if (!reg.test(cur) && cur) {
                this.error = 'illegalFname'
            }else if(cur.length > 50){
                this.error = 'groupLengthTooLong'
            }else{
                this.error = ''
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/team/CreateTeam.vue